import React from 'react';
import {
  ResponsiveContainer,
  ComposedChart,
  Line,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from 'recharts';

// Custom tooltip component to display additional data
const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const poHuidig = payload[0]?.value || 0;
    const poOud = payload[1]?.value || 0;
    const winstVerlies = payload[2]?.value || 0;
    const vermogensgroei = payload[2]?.payload?.vermogensgroei || 0;

    return (
      <div className="custom-tooltip">
        <p className="tooltip-label">{`${label}`}</p>
        <div className="tooltip-data">
          <p className="tooltip-revenue">{`PO Huidig: €${poHuidig.toLocaleString()}`}</p>
          <p className="tooltip-expenses">{`PO Oud: €${poOud.toLocaleString()}`}</p>
          <p className="tooltip-profit">{`Winst/Verlies: €${winstVerlies.toLocaleString()}`}</p>
          <p className="tooltip-details">{`Vermogensgroei: ${vermogensgroei.toLocaleString()}%`}</p>
        </div>
      </div>
    );
  }
  return null;
};

// Custom axis tick configuration
const axisTickStyles = {
  fill: '#ffffff', // White color for the tick text
  fontSize: '0.9rem',
  fontWeight: 500
};

const DataChart = ({ data }) => {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);
  
  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  return (
    <div className="chart-container">
      <h2>Factuah</h2>
      <ResponsiveContainer width="100%" height={isMobile ? 350 : 450}>
        <ComposedChart
          data={data}
          margin={{
            top: 20,
            right: isMobile ? 20 : 30,
            bottom: isMobile ? 30 : 20,
            left: isMobile ? 20 : 30,
          }}
        >
          <CartesianGrid stroke="#f5f5f5" opacity={0.3} />
          <XAxis
            dataKey="date"
            scale="band"
            tick={axisTickStyles}
            axisLine={{ stroke: '#ffffff', strokeWidth: 1.5 }}
            fontSize={isMobile ? "0.7rem" : "0.9rem"}
            angle={isMobile ? -45 : 0}
            textAnchor={isMobile ? "end" : "middle"}
            height={isMobile ? 60 : 30}
          />
          <YAxis
            tick={axisTickStyles}
            axisLine={{ stroke: '#ffffff', strokeWidth: 1.5 }}
            tickFormatter={(value) => `€${value}`}
            fontSize={isMobile ? "0.7rem" : "0.9rem"}
            width={isMobile ? 50 : 70}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend
            wrapperStyle={{ color: '#ffffff' }}
            formatter={(value) => <span style={{ color: '#ffffff' }}>{value}</span>}
          />
          <Bar dataKey="poHuidig" barSize={isMobile ? 15 : 20} fill="#8884d8" name="PO Huidig" />
          <Bar dataKey="poOud" barSize={isMobile ? 15 : 20} fill="#82ca9d" name="PO Oud" />
          <Line type="monotone" dataKey="winstVerlies" stroke="#ff7300" name="Winst/Verlies" strokeWidth={3} />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default DataChart; 